// Copyright 2021 Amazon.com, Inc. or its affiliates. All Rights Reserved.
import React from "react";
import { Navigator } from "../Navigator/Navigator";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import log from "../../logging";

const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            networkMode: "always",
            refetchOnWindowFocus: false,
        },
        mutations: {
            networkMode: "always",
        },
    },
});

export const App = () => {
    // TODO [LOWA-30534] Remove this once we fully migrate to the new step based flow
    log.info("Welcome! You are now using the new step based flow!");

    return (
        <div>
            <React.StrictMode>
                <QueryClientProvider client={queryClient}>
                    <Navigator />
                </QueryClientProvider>
            </React.StrictMode>
        </div>
    );
};
